<p8-settings-page >
  <p8-settings-header [titlePath]="['Documents', 'Ajouter documents']"></p8-settings-header>

  <div class="p8-bdc_document-new__container">
    <p8-file-picker #filePicker [(files)]="files"></p8-file-picker>
    <button mat-raised-button
            color="accent"
            class="p8-bdc_document-new__select-button"
            (click)="filePicker.click()"
            matTooltip="Sélectionner un fichier, la taille ne doit pas dépasser 10 Mo"
    >
      SÉLECTIONNER DOCUMENTS
    </button>

    <div *ngFor="let file of files; index as i">
      <div class="p8-bdc_document-new__block-container">
        <p8-bdc-document-form [file]="file"></p8-bdc-document-form>

        <div class="p8-bdc_document-new__buttons-container p8-secondary" fxLayout="row">
          <button mat-icon-button (click)="remove(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <p8-settings-footer>
    <button mat-raised-button
            color="accent"
            [disabled]="!isValid()"
            (click)="onSubmit()"
    >AJOUTER DOCUMENTS</button>
    <button mat-button (click)="onCancel()">ANNULER</button>
  </p8-settings-footer>
</p8-settings-page>
